import Vue from 'vue';
import store from './store';
import route from 'ziggy';
import { Ziggy } from './commons/dynamic-ziggy';

require('spark-bootstrap');
require('./components/bootstrap');
require('./bootstrap');
require('./filters');
require('./directives');
require('./slider');

const laroute = {route: (name, params, absolute) => route(name, params, absolute, Ziggy).url()};
window.laroute = laroute;
window.route = laroute.route;

Vue.prototype.$laroute = laroute;
Vue.prototype.$http = window.axios;
Vue.prototype.$user = Spark && Spark.state && Spark.state.user;
Vue.prototype.$alert = (options = {}) => {
    const title = options.title || (options.type === 'error' ? 'Error!' : options.type === 'success' ? 'Success!' : 'Warning!');
    return new Promise((resolve, reject) => {
        swal.fire({
            title,
            text: options.message || '',
            type: options.type || 'warning'
        }).then(confirm => {
            if (confirm.value) {
                resolve(confirm);
            } else {
                reject(confirm);
            }
        });
    });
};

Vue.prototype.$confirm = (options = {}) => {
    return new Promise((resolve, reject) => {
        swal.fire({
            title: options.title || 'Are you sure?',
            text: options.text || 'You will not be able to recover it!',
            type: options.type || 'warning',
            confirmButtonColor: options.confirmButtonColor || '#dc3545',
            confirmButtonText: options.confirmButtonText || 'Yes, delete it!',
            git : options.closeOnConfirm || false,
            disableButtonsOnConfirm: true,
            showLoaderOnConfirm: true,
            showCancelButton: true,
            html: false
        }).then(confirm => {
            if (confirm.value) {
                resolve(confirm);
            }
        }).catch(swal.noop);
    });
};

Vue.prototype.$log = console.log;

Vue.prototype.$confirmDialog = (options = {}) => {
    return new Promise(resolve => {
        return swal.fire({
            title: options.title || 'Are you sure?',
            text: options.text || 'You will not be able to recover it!',
            type: options.type || 'warning',
            confirmButtonColor: options.confirmButtonColor || '#dc3545',
            confirmButtonText: options.confirmButtonText || 'Yes, delete it!',
            closeOnConfirm: options.closeOnConfirm || false,
            disableButtonsOnConfirm: true,
            showLoaderOnConfirm: true,
            showCancelButton: true,
            html: options.html ? options.html : false,
        }).then(confirm => {
            if (confirm.value) {
                resolve(confirm);
            }
        });
    });
};

if (window.FB) {
    FB.init({
        appId: DevSquad.facebookAppId,
        cookie: true,
        xfbml: true,
        version: 'v2.12'
    });
    FB.AppEvents.logPageView();
}

Vue.mixin({
    methods: {
        scrollToFirstError() {
            this.$nextTick(() => {
                $('html, body').animate(
                    {
                        scrollTop: $('.invalid-feedback:first')
                            .closest('.form-group')
                            .offset().top
                    },
                    200
                );
            });
        }
    }
});

new Vue({
    mixins: [require('spark')],
    store,
    mounted() {
        $('[title]').tooltip({
            delay: {show: 500}
        });
    }
});
